import * as Yup from 'yup';

// Alinhado com o regex do CDT-Pessoa (backend EmailUtil.EMAIL_PATTERN e
// helpers.validateEmail). Manter sincronizado nos três lugares.
export const EMAIL_REGEX = /^[_A-Za-z0-9\-+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;
const EMAIL_INVALID_MSG = 'E-mail inválido. Use o formato: usuario@dominio.com.br';

export const userValidationSchema = Yup.object().shape({
    deCpfCnpj: Yup.string().required('Campo obrigatório'),
    nmUsuario: Yup.string().required('Informação é obrigatória'),
    deEmail: Yup.string().matches(EMAIL_REGEX, EMAIL_INVALID_MSG).required('Campo obrigatório'),
});

export const accessPortalSchema = Yup.object().shape({
    deCpfCnpj: Yup.string().required('Campo obrigatório'),
    nmUsuario: Yup.string().required('Informação é obrigatória'),
    deCep: Yup.string().required('Campo obrigatório'),
    uf: Yup.string().required('Campo obrigatório'),
    municipio: Yup.string().required('Campo obrigatório'),
    deBairro: Yup.string().required('Campo obrigatório'),
    deEndereco: Yup.string().required('Campo obrigatório'),
    deEmail: Yup.string().matches(EMAIL_REGEX, EMAIL_INVALID_MSG).required('Campo obrigatório'),
    deSenha: Yup.string().required('Campo obrigatório'),
    deTelefone: Yup.string().required('Campo obrigatório'),
});

export const changeEmailSchema = Yup.object().shape({
    deCpfCnpj: Yup.string().required('Campo obrigatório'),
    deNewEmail: Yup.string().matches(EMAIL_REGEX, EMAIL_INVALID_MSG).required('Campo obrigatório'),
    deMotivo: Yup.string().required('Informação é obrigatória'),
    deObservacao: Yup.string().when('deMotivo', {
        is: 'Outros',
        then: Yup.string().required('Campo obrigatório'),
    }),
});

const validaCaracteres = { naoPermitidos: ['*', '?', '%'] };
validaCaracteres.regex = new RegExp(`^[^${validaCaracteres.naoPermitidos.join('')}]*$`);
validaCaracteres.erro = `Os seguintes caracteres não são permitidos: ${validaCaracteres.naoPermitidos.map((char) => `'${char}'`).join(', ')}`;

export const registrationValidationSchema = Yup.object().shape({
    flRepresentacao: Yup.string(),
    deCnpjMatriz: Yup.string().required('Campo obrigatório'),
    deCnpjFilial: Yup.string().when('flRepresentacao', {
        is: 'F',
        then: Yup.string().required('Campo obrigatório'),
    }),
    deRazaoSocial: Yup.string().matches(validaCaracteres.regex, validaCaracteres.erro).required('Campo obrigatório'),
    nmFantasia: Yup.string().matches(validaCaracteres.regex, validaCaracteres.erro).required('Campo obrigatório'),
    cdTipoEmpresa: Yup.string().required('Campo obrigatório'),
    cdRamoAtividade: Yup.string().required('Campo obrigatório'),
    deEmail: Yup.string().matches(EMAIL_REGEX, EMAIL_INVALID_MSG).required('O email é obrigatório'),
    deTelefone: Yup.string().required('Campo obrigatório'),
    enderecoMatriz: Yup.object().shape({
        deCep: Yup.string().required('Campo obrigatório'),
        uf: Yup.string().required('Campo obrigatório'),
        municipio: Yup.object()
            .shape({
                cdMunicipio: Yup.number().required('Campo obrigatório'),
            })
            .required('Campo obrigatório'),
        deBairro: Yup.string().required('Campo obrigatório'),
        deEndereco: Yup.string().required('Campo obrigatório'),
    }),
    enderecoFilial: Yup.object().when('flRepresentacao', {
        is: 'F',
        then: Yup.object().shape({
            deCep: Yup.string().required('Campo obrigatório'),
            uf: Yup.string().required('Campo obrigatório'),
            municipio: Yup.object()
                .shape({
                    cdMunicipio: Yup.number().required('Campo obrigatório'),
                })
                .required('Campo obrigatório'),
            deBairro: Yup.string().required('Campo obrigatório'),
            deEndereco: Yup.string().required('Campo obrigatório'),
        }),
    }),
    dtFundacao: Yup.date().required('Campo obrigatório').typeError('Data inválida').nullable(),
    tpRegistro: Yup.string().required('Campo obrigatório'),
    deRegistro: Yup.string().required('Campo obrigatório'),
    dtRegistro: Yup.date().required('Campo obrigatório').typeError('Data inválida').nullable(),
    dtArquivamento: Yup.date().typeError('Data inválida').nullable(),
    tpControleAcionario: Yup.string().required('Campo obrigatório'),
    vlCapital: Yup.string().required('Campo obrigatório'),
});

export const registrationPersonValidationSchema = Yup.object().shape({
    cdTipoPessoaFisica: Yup.string().required('Campo obrigatório'),
    deCpf: Yup.string().required('Campo obrigatório'),
    nmCompleto: Yup.string().matches(validaCaracteres.regex, validaCaracteres.erro).required('Campo obrigatório'),
    dtNascimento: Yup.date().required('Campo obrigatório').typeError('Data inválida').nullable(),
    deRg: Yup.string().required('Campo obrigatório'),
    dtRg: Yup.date().required('Campo obrigatório').typeError('Data inválida').nullable(),
    sgOrgaoRg: Yup.string().required('Campo obrigatório'),
    sgUfRg: Yup.string().required('Campo obrigatório'),
    deCnh: Yup.number().typeError('Apenas números são permitidos').required('Campo obrigatório'),
    dtValidadeCnh: Yup.date().required('Campo obrigatório').typeError('Data inválida').nullable(),
    tpCategoriaCnh: Yup.string().required('Campo obrigatório'),
    sgUfCnh: Yup.string().required('Campo obrigatório'),
    deFiliacaoPai: Yup.string().required('Campo obrigatório'),
    deFiliacaoMae: Yup.string().required('Campo obrigatório'),
    nuInss: Yup.number().typeError('Apenas números são permitidos').required('Campo obrigatório'),
    deEmail: Yup.string().matches(EMAIL_REGEX, EMAIL_INVALID_MSG).required('O email é obrigatório'),
    deTelefone: Yup.string().required('Campo obrigatório'),
    enderecoPessoa: Yup.object().shape({
        deCep: Yup.string().required('Campo obrigatório'),
        uf: Yup.string().required('Campo obrigatório'),
        municipio: Yup.object()
            .shape({
                cdMunicipio: Yup.number().required('Campo obrigatório'),
            })
            .required('Campo obrigatório'),
        deBairro: Yup.string().required('Campo obrigatório'),
        deEndereco: Yup.string().required('Campo obrigatório'),
    }),
});

export const camposObrigatoriosPadraoVehicleForm = {
    nmOperador: true,
    boProprietario: true,
    nmProprietario: true,
    deCpfCnpjProprietario: true,
    dePlaca: true,
    deRenavam: true,
    cdCategoriaVeiculo: true,
    deChassi: true,
    nuAnoFabricacao: true,
    cdMarca: true,
    cdModeloVeiculo: true,
    nuAnoModelo: true,
    cdTipoCombustivel: true,
    vlPotenciaMotor: true,
    municipio: true,
    qtCapacidade: true,
    deUtilizacao: true,
    cdSubSistema: true,
    cdTipoVeiculo: true,
    cdClassificacaoVeiculo: true,
    documentos: true,
};

export const validacoesVehicleForm = {
    dePlaca: Yup.string().matches(/^([A-Za-z]{3}[0-9]{1}[0-9A-Za-z]{1}[0-9]{2})$/, 'Formato inválido.'),
    deRenavam: Yup.string().matches(/^[0-9]*$/, 'Apenas números são permitidos.'),
    nuAnoFabricacao: Yup.number()
        .typeError('Apenas números são permitidos')
        .min(1900, 'Ano inválido')
        .max(2100, 'Ano inválido'),
    nuAnoModelo: Yup.number()
        .typeError('Apenas números são permitidos')
        .min(1900, 'Ano inválido')
        .max(2100, 'Ano inválido'),
    vlPotenciaMotor: Yup.number().typeError('Apenas números são permitidos'),
    municipio: Yup.object().shape({ cdMunicipio: Yup.number().required('Campo obrigatório') }),
    qtCapacidade: Yup.string().matches(/^[0-9]*$/, 'Apenas números são permitidos.'),
    // nuOrdemEmpresa: Yup.string().matches(/^[0-9]*$/, 'Apenas números são permitidos.'),
    nuAgerba: Yup.string().matches(/^[0-9]*$/, 'Apenas números são permitidos.'),
    nuAnoIpva: Yup.number()
        .typeError('Apenas números são permitidos')
        .min(1900, 'Ano inválido')
        .max(2100, 'Ano inválido'),
    documentos: Yup.array(),
};

export const addRequiredFields = (requiredFieldToBooleanObject, existingValidations, surveyValidationSchema = null) => {
    const validations = { ...existingValidations };
    for (let key in requiredFieldToBooleanObject) {
        if (requiredFieldToBooleanObject[key]) {
            validations[key] = (existingValidations[key] ?? Yup.string()).required('Campo obrigatório');
        }
    }
    if (!surveyValidationSchema) return Yup.object().shape(validations);
    return Yup.object().shape(validations).concat(surveyValidationSchema);
};

export const vehicleValidationSchema = addRequiredFields(camposObrigatoriosPadraoVehicleForm, validacoesVehicleForm);

export const surveyValidationSchema = Yup.object().shape({
    boVeiculoNovo: Yup.boolean(),
    documentos: Yup.array().test('required-documents', 'Campo obrigatório',
        function (value) {
            const { nuDocumentosVistoria = 0 } = this.parent || {};
            return value.length >= nuDocumentosVistoria;
        }),
    idVistoria: Yup.string().when('boVeiculoNovo', {
        is: (boVeiculoNovo) => boVeiculoNovo === false,
        then: Yup.string()
            .required('Campo obrigatório')
            .max(20, 'O campo deve ter no máximo 20 caracteres'),
        otherwise: Yup.string().notRequired(),
    }),
    tpSituacao: Yup.string().when('boVeiculoNovo', {
        is: (boVeiculoNovo) => boVeiculoNovo === false,
        then: Yup.string().required('Resultado da vistoria inválido'),
        otherwise: Yup.string().notRequired(),
    }),
    cdMunicipioVistoria: Yup.number().when('boVeiculoNovo', {
        is: (boVeiculoNovo) => boVeiculoNovo === false,
        then: Yup.number().required('Município da vistoria inválido'),
        otherwise: Yup.number().notRequired(),
    }),
    nuValorBem: Yup.number().when('boVeiculoNovo', {
        is: (boVeiculoNovo) => boVeiculoNovo === true,
        then: Yup.number().required('Campo obrigatório')
            .min(0.01, 'Valor do bem inválido')
            .max(999999999.99, 'Valor do bem inválido'),
        otherwise: Yup.number().notRequired(),
    }),
});

export const inspectionReportValidationSchema = Yup.object().shape({
    cdMunicipioVistoria: Yup.string().required('Campo obrigatório').nullable(),
    cdVistoriador: Yup.string().required('Campo obrigatório').nullable(),
    dtVistoria: Yup.date().required('Campo obrigatório').typeError('Data inválida').nullable(),
    hrVistoria: Yup.string()
        .required('Campo obrigatório')
        .matches(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/, 'Hora inválida'),
    // tpSituacao: Yup.string().required('Campo obrigatório'),
});

export const licensesValidationSchema = Yup.object()
    .shape({
        nuMeses: Yup.string().required('Campo obrigatório').nullable(),
        boMatutino: Yup.boolean(),
        boNoturno: Yup.boolean(),
        boVespertino: Yup.boolean(),
    })
    .test('frequencyTest', null, ({ boMatutino, boNoturno, boVespertino }) => {
        if (boMatutino || boNoturno || boVespertino) {
            return true;
        }

        return new Yup.ValidationError('Selecione um dos campos', null, 'frequencyTest');
    });

export const licensesTourismValidationSchema = Yup.object().shape({
    nuMeses: Yup.string().required('Campo obrigatório').nullable(),
});

export const licensesEventualValidationSchema = Yup.object().shape({
    dtViagem: Yup.date().required('Campo obrigatório').typeError('Data inválida').nullable(),
    dtRetorno: Yup.date().required('Campo obrigatório').typeError('Data inválida').nullable(),
});

export const healthLicenseValidationSchema = licensesValidationSchema.shape({
    deResponsavel: Yup.string().required('Campo obrigatório'),
    deRgResponsavel: Yup.string().required('Campo obrigatório'),
});

export const lineValidationSchema = Yup.object().shape({
    // deJustificativa: Yup.string().required('Campo obrigatório'),
});

export const stripLineValidationSchema = Yup.object().shape({
    deJustificativa: Yup.string().required('Campo obrigatório'),
});
